import request from '@/utils/service'

export function userListApi(data) {
  return request({
    url: '/xdUser/list',
    method: 'get',
    params: data
  })
}

export function userDetailApi(data) {
  return request({
    url: '/xdUser/detail',
    method: 'get',
    params: data
  })
}

export function userStatusApi(data) {
  return request({
    url: '/xdUser/updateStatus',
    method: 'post',
    data
  })
}

export function userWalletFlowApi(data) {
  return request({
    url: '/xdWalletTxFlow/list',
    method: 'get',
    params: data
  })
}

export function userWithdrawApi(data) {
  return request({
    url: '/xdUser/withdraw',
    method: 'post',
    data
  })
}

export function userWalletFlowSum(data) {
  return request({
    url: '/xdWalletTxFlow/userWalletFlowSum',
    method: 'get',
    params: data
  })
}

// 赠送金额
export function giveSum(data) {
  return request({
    url: '/xdUser/giveSum',
    method: 'post',
    data
  })
}
